import R from "ramda";
import {
  SET_USAGE_DETAILS,
  SET_DOCUMENT_USAGE_DETAILS,
  SET_PENDING_DOCUMENTS,
  DASHBOARD_LOADING_STOP
} from "actions/dashboard-actions";

export const initialState = {
  documentCount: 0,
  documentLimit: 0,
  envelopeCount: 0,
  envelopeLimit: 0,
  isLoading: true,
  pendingDocumentCount: 0,
  totalCount: 0,
  totalSumFiltered: null
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USAGE_DETAILS:
      return stateForSetUsageDetails(state, action.data);
    case SET_DOCUMENT_USAGE_DETAILS:
      return stateForSetDocumentUsageDetails(state, action);
    case SET_PENDING_DOCUMENTS:
      return R.merge(state, { pendingDocumentCount: action.data.pendingDocumentCount });
    case DASHBOARD_LOADING_STOP:
      return R.merge(state, { isLoading: false });
    default:
      return state;
  }
};

const stateForSetUsageDetails = (state, data) => (
  R.merge(state, {
    documentCount: data.usageDetails.totalProcessedCount,
    documentLimit: data.usageDetails.documentLimitPerMonth,
    envelopeCount: data.usageDetails.billableEnvelopeCount,
    envelopeLimit: data.usageDetails.envelopeLimitPerMonth
  })
);

const stateForSetDocumentUsageDetails = (state, action) => (
  R.merge(state, {
    totalCount: action.data.totalCount,
    totalSumFiltered: action.data.totalSumFiltered.amount.toFixed(0)
  })
);



// WEBPACK FOOTER //
// ./src/js/reducers/dashboard-reducer.js